<template>
    <div class="payDalog">
      <el-dialog  :visible.sync="payDalog" width="600px"  :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div class="contentElDialog">
                <div class="title">
                    <div class="text">确认支付</div>
                    <img class="tanx" src="../components/images/tanx.png" alt="" @click="closeDialog()">
                </div>
                <div class="formContent">
                    <div class="list">
                        <div class="lable">订单类型：</div>
                        <div class="text">版权登记</div>
                    </div>
                    <div class="list boderDashedM">
                        <div class="lable">订单金额：</div>
                        <div class="money">¥{{(payMoney.bizPrice / 100).toFixed(2)}}</div>
                    </div>
                    <div class="list boderDashedP">
                        <div class="lable">支付方式：</div>
                        <div class="payBox">
                            <div class="item " :class="payBoxIdex == index?'active':''" v-for="(item,index) in payWayList" :key="index" @click="onPayWay(item,index)">
                                <img class="iocn"  :src="item.img" alt="">
                                <div class="t">{{item.name}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="payCode">
                    <img class="code"  :src="payCode" alt="">
                </div>
            </div>
      </el-dialog>
    </div>
</template>

<script>
		import {getPayInfoByOrderSeqNo,getPayStatusByOrderSeqNo,configGetBzPrice,updateUrgentInfo} from "@/api/index.js";
		
    export default {
        name: "payDalog",
        props: {
           
        },
        components: {
        },
        data() {
            return {
							zhouqi: [
									{
											name: '标准',
											text: '5-7工作日出证',
											code: '020303',
											state: 1
									},
									{
											name: '加急办理',
											text: '3工作日出证',
											code: '020302',
											state: 2
									},
									{
											name: '加急办理',
											text: '1工作日出证',
											code: '020301',
											state: 2
									}
							],
              payBoxIdex: 0,
							tiemBoxIdx: 0,
							payDalog: false,
							payCode: '',
							payWay: 'AliPay',
							payMoney: 0,
							payOrder: {
								orderSeqNo: ''
							},
							payWayList: [
								{
									name: '支付宝支付',
									payWay: 'AliPay',
									img: require('../assets/alipay.png')
								},
								{
									name: '微信支付',
									payWay: 'WechatPay',
									img: require('../assets/wxpay.png')
								}
							],
							orderType: '',
							setTime: null,
							bizTypeBy: '',
							subBizTypeBy: '',
							orderData: {},
							payMoney: {
								bizPrice: 0
							},
							urgentDayType: '020303',
							operationType: 1,
							flag: false
            }
        },
        computed: {
        },
        watch: {
            $route(to, from) {
            }
        },
        mounted() {
					
        },
				destroyed () {
					clearInterval(this.setTime)
				},
        methods: {
					// 获取金额
            async configGetBzPrice(item) {
                let data = {
										bizType: '02', // 登记
										subBizType: item.copyrightRegister.subBizType
								}
								this.orderData = item.orderSeqNo
								this.urgentDayType = item.copyrightRegister.subBizType
                let res = await configGetBzPrice(data)
                this.payMoney = res.result
								this.getPayInfoByOrderSeqNo()
            },

						async configGetBzPrice2(item) {
                let data = {
										bizType: '02',
										subBizType: item.urgentDayType
								}
								this.orderData = item.orderSeqNo
								this.urgentDayType = item.urgentDayType
                let res = await configGetBzPrice(data)
                this.payMoney = res.result
								this.getPayInfoByOrderSeqNo()
            },
						async configGetBzPrice3(item,flag) {
                let data = {
										bizType: '02',
										subBizType: item.subBizType
								}
								this.flag = flag
								this.orderData = item.orderSeqNo
								this.urgentDayType = item.subBizType
                let res = await configGetBzPrice(data)
                this.payMoney = res.result
								this.getPayInfoByOrderSeqNo()
            },

            closeDialog() {
              this.payDalog = !this.payDalog 
							// this.$emit('confirm',this.dataObj)
							if (!this.flag) {
								this.$emit('confirm',this.dataObj)
							}
							clearInterval(this.setTime)
            },
						confirm() {
							this.closeDialog()
              this.$emit('confirm',this.dataObj)
            },
						// 支付
						onPayWay(item,index) {
							this.payBoxIdex = index
							this.payWay = item.payWay
							clearInterval(this.setTime)
							this.getPayInfoByOrderSeqNo(this.orderData)
						},
						getPayInfoByOrderSeqNo() {
								let that = this
								let data = {
										payWay: that.payWay,
										orderSeqNo: that.orderData,
										bizType: '02',
										subBizType: that.urgentDayType,
								}
								getPayInfoByOrderSeqNo(data).then( res => {
										that.payCode = res.result.qr
										that.payDalog  = true
										that.setTime = setInterval(that.getPayStatusByOrderSeqNo,3000)
								})
						},
						//定时查看有没有支付成功
						getPayStatusByOrderSeqNo() {
							let that = this
							let data = {
								orderSeqNo: that.orderData,
								bizType: '02',
								subBizType: that.urgentDayType,
							}
							getPayStatusByOrderSeqNo(data).then( res => {
				
								if (res.result.payStatus == 'paid') {
									that.payDalog  = false
									this.$emit('confirm')
									clearInterval(this.setTime)
								}
							})
						}
        },
        beforeDestroy() {}
    };
</script>

<style lang="less" scoped>
.contentElDialog{
	background: #fff;
	.title{
			display: flex;
			align-items: center;
			height: 66px;
			border-bottom: solid 1px #E5E5E5;
			padding: 0 26px;
			.text{
					font-size: 16px;
					font-weight: 700;
					color: #333;
			}
			.tanx{
					width: 14px;
					height: 14px;
					margin-left: auto;
					cursor: pointer;
			}
	}
	.formContent{
		padding: 33px;
		
		.list{
			display: flex;
			align-items: center;
			padding-bottom: 16px;
			.lable{
				font-size: 14px;
				color: #999999;
				margin-right: 24px;
			}
			.text{
				flex: 1;
			}
			.timeBox{
				display: flex;
				align-items: center;
				.item{
					color: #666666;
					border: solid 1px #E5E5E5;
					border-radius:4px;
					font-size: 14px;
					padding: 9px 14px;
					margin-right: 12px;
					cursor: pointer;
					&:last-child{
						margin-right: 0;
					}
				}
				.active{
					color: #2196F3;
					border: solid 1px #2196F3;
					background-color: rgba(32, 150, 243, 0.1);
				}
			}
			.money{
				font-size: 26px;
				font-weight: 700;
				color: #FF2121;
			}
			.payBox{
				display: flex;
				align-items: center;
				.item{
					display: flex;
					align-items: center;
					border: solid 1px #E5E5E5;
					padding: 8px 46px;
					margin-right: 19px;
					border-radius:4px;
					cursor: pointer;
					&:last-child{
						margin-right: 0;
					}
					.iocn{
						width: 32px;
						height: 32px;
            margin-right: 5px;
					}
				}
				.active{
					color: #2196F3;
					border: solid 1px #2196F3;
					background-color: rgba(32, 150, 243, 0.1);
				}
			}
		}
		.boderDashedP{
			padding: 20px 0;
		}
		.boderDashedM{
			border-bottom: dashed 1px #E5E5E5;
			padding: 15px 0;
		}
		.boderDashed{
			border-bottom: dashed 1px #E5E5E5;
			padding-bottom: 32px;
		}
	}
	.payCode{
		padding-bottom: 44px;
		.code{
			width: 206px;
			height: 206px;
			margin: auto;
		}
	}
}
.payDalog{
    /deep/ .el-dialog{
        border-radius: 16px;
        overflow: hidden;
        position: absolute;
        margin: auto !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    /deep/ .el-dialog__body{
        padding: 0;
    }
    /deep/ .el-dialog__header{
        padding: 0;
    }
}
</style>
